import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:client', _ctx.client?.sys?.id, $event))),
    title: "General client information",
    layout: "grid",
    "model-value": _ctx.client,
    "column-count": 2
  }, {
    default: _withCtx(({ editState }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_editable_block_input, {
          label: "Project ID",
          modelValue: editState.id,
          "onUpdate:modelValue": ($event: any) => ((editState.id) = $event),
          tooltip: "The project ID is automatically generated by Directify. "
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_editable_block_input, {
          label: "Company name",
          modelValue: editState.company_name,
          "onUpdate:modelValue": ($event: any) => ((editState.company_name) = $event)
        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
        (editState.contact)
          ? (_openBlock(), _createBlock(_component_editable_block_input, {
              key: 0,
              label: "Contact person",
              modelValue: editState.contact.name,
              "onUpdate:modelValue": ($event: any) => ((editState.contact.name) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (editState.contact)
          ? (_openBlock(), _createBlock(_component_editable_block_input, {
              key: 0,
              label: "Phone number",
              modelValue: editState.contact.phone,
              "onUpdate:modelValue": ($event: any) => ((editState.contact.phone) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true),
        (editState.contact)
          ? (_openBlock(), _createBlock(_component_editable_block_input, {
              key: 1,
              label: "Email address",
              modelValue: editState.contact.email,
              "onUpdate:modelValue": ($event: any) => ((editState.contact.email) = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}